const tokenKey = 'token';
const refreshTokenKey = 'refreshToken';

export const setItem = (key: string, value: any): void =>
  localStorage.setItem(key, JSON.stringify(value));

export const getItem = (key: string): any => {
  if (typeof window == 'undefined') {
    return null;
  }
  const value = localStorage.getItem(key);

  return value ? JSON.parse(value) : null;
};
export const getRawItem = (key: string): any => {
  if (typeof window == 'undefined') {
    return null;
  }
  return localStorage.getItem(key);
};

export const setSession = (
  session: { token: string; refreshToken: string } | null
): void => {
  setItem(tokenKey, session?.token);
  setItem(refreshTokenKey, session?.refreshToken);
};

export const getSession = (): {
  token: string;
  refreshToken: string;
} | null => {
  return {
    refreshToken: getRawItem(refreshTokenKey),
    token: getRawItem(tokenKey)
  };
};

export const deleteSession = (): void => {
  setSession(null);
};
